<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="task-upload-buttons">
        <div>
          <el-upload class="upload-demo"
                     ref="upload"
                     action=""
                     :auto-upload="false"
                     :on-change="query => onUploadFile(query,1)"
                     accept=".xlsx,.xls"
                     :show-file-list="false">
            <el-button icon="sj-icon-add"
                       type="primary"
                       size="mini">批量添加平台用户角色
            </el-button>
          </el-upload>
        </div>
        <div>
          <el-upload class="upload-demo"
                        ref="upload"
                        action=""
                        :auto-upload="false"
                        :on-change="query => onUploadFile(query,2)"
                        accept=".xlsx,.xls"
                        :show-file-list="false">
          <el-button icon="sj-icon-add"
                     type="primary"
                     size="mini">批量删除平台用户角色
          </el-button>
        </el-upload>
        </div>
        <div>
          <el-upload class="upload-demo"
                     ref="upload"
                     action=""
                     :auto-upload="false"
                     :on-change="query => onUploadFile(query,3)"
                     accept=".xlsx,.xls"
                     :show-file-list="false">
            <el-button icon="sj-icon-add"
                       type="primary"
                       size="mini">批量更新平台用户邮箱
            </el-button>
          </el-upload>
        </div>
<!--        <div>-->
<!--          <el-dropdown split-button-->
<!--                       type="primary"-->
<!--                       size="mini"-->
<!--                       @click="e => onClickUpload(e, 'addUser')"-->
<!--                       trigger="click">-->
<!--            <span>批量添加实习生</span>-->
<!--            <el-upload-->
<!--              ref="addUser"-->
<!--              action-->
<!--              style="display: none"-->
<!--              accept=".xlsx"-->
<!--              :auto-upload="false"-->
<!--              :on-change="query => onUploadAdminUserFile(query, 263, 'addUser')"-->
<!--              :show-file-list="false"-->
<!--            />-->
<!--            <el-dropdown-menu slot="default">-->
<!--              <el-dropdown-item @click.native="downloadAddUserDemo">下载Demo文件</el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </el-dropdown>-->
<!--        </div>-->
<!--        <div>-->
<!--          <el-dropdown split-button-->
<!--                       type="primary"-->
<!--                       size="mini"-->
<!--                       @click="e => onClickUpload(e, 'editUser')"-->
<!--                       trigger="click">-->
<!--            <span>批量修改实习生</span>-->
<!--            <el-upload-->
<!--              ref="editUser"-->
<!--              action-->
<!--              style="display: none"-->
<!--              accept=".xlsx"-->
<!--              :auto-upload="false"-->
<!--              :on-change="query => onUploadAdminUserFile(query, 264, 'editUser')"-->
<!--              :show-file-list="false"-->
<!--            />-->
<!--            <el-dropdown-menu slot="default">-->
<!--              <el-dropdown-item @click.native="downloadAddUserDemo">下载Demo文件</el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </el-dropdown>-->
<!--        </div>-->
        <div v-if="users.usertype + '' === '1'">
          <el-dropdown split-button
                       @click="e => onClickUpload(e, 'uploadSJIdCardRegion')"
                       type="primary"
                       size="mini"
                       trigger="click">
            <span>上传身份证行政区划</span>
            <el-upload ref="uploadSJIdCardRegion"
                       action=""
                       style="display: none"
                       accept=".xlsx"
                       :auto-upload="false"
                       :on-change="query => onUploadFile(query, 4)"
                       :show-file-list="false"/>
            <el-dropdown-menu slot="default">
              <el-dropdown-item @click.native="downloadSJIdCardRegionFile">下载当前数据</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="50"></el-table-column>
        <el-table-column prop="display_name"
                         label="名称"
                         min-width="120">
          <template slot-scope="scope">
            <span style="cursor:pointer;color:rgb(88,157,248)"
                  @click="onDownSourceFile(scope.row.id)">{{scope.row.display_name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="admin_name"
                         label="发起者"
                         min-width="120"></el-table-column>
        <el-table-column prop="created_at"
                         label="上传时间"
                         min-width="120"></el-table-column>
        <el-table-column label="任务进度"
                         min-width="120">
          <template slot-scope="scope">
            <sj-progress :text-inside="true"
                         :stroke-width="18"
                         :status="taskBatchStatus(scope.row)"
                         :percentages="taskBatchPercentage(scope.row)"></sj-progress>
            成功:{{scope.row.success_count}} 错误:{{scope.row.error_count}}
          </template>
        </el-table-column>
        <el-table-column prop="task_type"
                         label="类型"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.task_type"
                  v-if="scope.row.task_type === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in status"
                  v-if="scope.row.status === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <span v-if="(scope.row.status === 3 && scope.row.error_count > 0) || scope.row.status === -2">
              <el-button type="text"
                         size="mini"
                         @click="onDownErrorFile(scope.row.id)">下载错误行</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import downloadJS from 'downloadjs'
import SjProgress from '@/components/sj-progress'
import taskBatchMixins from '@/views/task-batch/task-batch.mixins'

export default {
  mixins: [table, taskBatchMixins],
  components: {SjProgress},
  data () {
    return {
      options: {
        task_type: [
          {value: 212, label: '批量角色添加'},
          {value: 213, label: '批量角色删除'},
          {value: 233, label: '批量更新平台用户邮箱'},
          {value: 263, label: '批量添加平台用户'},
          {value: 264, label: '批量编辑平台用户'},
        ],
      },
      search: {
        collection_type: 8,
        number: this.$route.params.number || '',
      },
    }
  },
  computed: Vuex.mapState({
    status: state => state.taskBatch.status,
    users: state => state.login.user,
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.common('queryBatchUpload', params)
    },
    onDownSourceFile (id) {
      downloadJS(request.items.downSourceFile(id))
    },
    onDownErrorFile (id) {
      downloadJS(request.items.downErrorFile(id))
    },
    onUnprocessFile (id) {
      downloadJS(request.items.downUnprocessFile(id))
    },
    onUploadFile (file, type) {
      let isLt10M = file.raw.size / 1024 / 1024 < 5
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)
      if (type === 1) {
        this.batchUploadAddRole(formData)
      } else if (type === 2) {
        this.batchUploadDelRole(formData)
      } else if (type === 3) {
        this.batchUploadUpdateEmail(formData)
      } else if (type === 4) {
        this.uploadSJIdCardRegionFile(formData)
      } else {
        return false
      }
    },

    batchUploadAddRole (formData) {
      request.common('batchUploadAddRole', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    batchUploadDelRole (formData) {
      request.common('batchUploadDelRole', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    batchUploadUpdateEmail (formData) {
      request.common('batchUploadUpdateEmail', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
    onClickUpload (e, refName) {
      e.stopPropagation()
      this.$refs[refName].$refs['upload-inner'].handleClick()
    },
    downloadAddUserDemo () {
      this.$export('批量添加实习生', [
        {
          'name': '刘某人',
          'phone': '15623450851',
          'mail_address': 'jake@so-in.com',
          'status': '活跃|待机|离职',
          'department_name': '公关部',
          'desc': '',
          'customerid': '123,982,81',
          'role_ids': '981,93,123',
          'permission_ids': '981,93,123',
        },
        {
          'name': '手机号必填，其他需修改字段按需添加，更新方式为覆盖更新，单元格为空时跳过不更新'
        },
        {
          'name': '提示：上传时请删除示例数据',
        },
      ], {
        fileHeader: [
          {
            key: 'name',
            text: '用户名',
          },
          {
            key: 'phone',
            text: '手机号',
          },
          {
            key: 'mail_address',
            text: '邮箱',
          },
          {
            key: 'status',
            text: '状态',
          },
          {
            key: 'department_name',
            text: '部门',
          },
          {
            key: 'desc',
            text: '备注',
          },
          {
            key: 'customerid',
            text: '客户权限',
          },
          {
            key: 'role_ids',
            text: '角色权限',
          },
          {
            key: 'permission_ids',
            text: 'UI角色权限',
          },
        ]
      })
    },
    onUploadAdminUserFile (file, taskType, ref) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10

      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs[ref].clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)
      formData.append('collection_type', 8)
      formData.append('type', taskType)

      request.common('createTaskBatch', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch({})
      })
    },
    uploadSJIdCardRegionFile (formData) {
      request.common('uploadSJIdCardRegionFileApi', formData).then(({data}) => {
        this.$message.success('身份证行政区划文件上传成功')
      })
    },
    downloadSJIdCardRegionFile () {
      const fileHeader = [
        {key: 'code', text: '行政区划代码'},
        {key: 'name', text: '单位名称'},
      ]
      const regions = []
      request.common('getSJIdCardRegionFileApi', {}).then(({data}) => {
        for (const code in data) {
          regions.push({code: code, name: data[code]})
        }
        this.$export('身份证行政区划当前数据文件', regions, {fileHeader})
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.task-upload-buttons {
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  margin-bottom: 10px;

  & > div {
    margin-right: 20px;
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/platform-upload/pages/PlatformUploadTable.vue